import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import VueFetchRoute from 'vue-fetch-route';
import VueLog from '@dreipol/vue-log';
import vSelect from 'vue-select';
import VueScrollTo from 'vue-scrollto';

import { createStore } from 'framework/vuex/store';
import vuexViewportMixin from 'framework/vuex/modules/viewport/mixin';
import vuexScrollMixin from 'framework/vuex/modules/scroll/mixin';
import registry from './registry';
import vueLogConfig from './vue-log-config';
import Axios from 'util/service';

const CMS = window.CMS;
const isInCMS = Boolean(CMS);



/**
 * Bootstrap the vue root instance
 * @return {Promise} A promise returning when the registry has loaded all components and the app was initialized
 */
export function init() {
    // NOTE: Plugin initialisation is run before registry because new merge strategies might be applied by plugins.
    Vue.use(VueScrollTo);
    Vue.use(Vuex);
    Vue.use(VueRouter);
    Vue.use(VueLog, vueLogConfig);
    Vue.use(VueFetchRoute, {
        log: Vue.log({ context: { location: 'vue-fetch-route' } }).debug,
        fetch(url) {
            return new Promise((resolve, reject) => {
                Axios.request({ url }).then(
                    ({ data, headers }) => {
                        const { appVersion } = globals.config;
                        const serverAppVersion = headers['x-app-version'];
                        const canCompareAppVersions = serverAppVersion && appVersion;

                        if (canCompareAppVersions && appVersion !== serverAppVersion) {
                            // NOTE: Git commit hash changed, we need to reload to ensure we're on the last version
                            window.location.reload();
                        } else {
                            resolve(data);
                        }
                    },
                    error => reject(error),
                );
            });
        },
        ignoredQueryParams: ['partials', 'edit', 'edit_off', 'language'],
        vuexModule: 'router',
    });
    Vue.component('v-select', vSelect);

    // if we are logged into the CMS we need to stop the vue warnings
    // the django-CMS will add dirty stuff to the DOM and vue doesn't like it
    Vue.config.silent = isInCMS;

    return registry().then(() => {
        const store = createStore({ strict: process.env.NODE_ENV !== 'production' });
        const AppRoot = new Vue({
            store,
            mixins: [vuexViewportMixin, vuexScrollMixin],
            mounted() {
                document.getElementById('root').classList.add('vue-ready--mounted');
            },
        });

        AppRoot.$mount('#root');

        // If logged into the CMS we need to refresh the plugins after the vue rendering
        // this is needed to enable the frontend editing
        if (isInCMS) {
            requestAnimationFrame(() => {
                CMS.Plugin._refreshPlugins();
            });
        }
    });
}
